var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('NewPromoForm'),_vm._l((_vm.property.promo),function(promo){return _c('PromoHistoryCard',{key:promo.id,attrs:{"promo":promo}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }